import React from 'react';
import PlainCRUD from 'components/PaginatedPlainCRUD';
import {
  deletePlaca,
  getPlacas,
  patchPlaca,
  postPlaca,
  baseURI,
} from 'api/recaudacion/placas';

// eslint-disable-next-line react/prop-types
const PlacasVehiculares = ({ permission }) => (
  <PlainCRUD
    title="Placas"
    permission={permission}
    get={getPlacas}
    post={postPlaca}
    patch={patchPlaca}
    delete={deletePlaca}
    withoutState
    allowImport
    baseURI={baseURI}
    tableProps={{ pageSize: 12 }}
    fields={[
      {
        name: 'numero_de_placa',
        label: 'Número de placa',
        required: true,
        colWidth: 50,
      },
    ]}
  />
);

export default PlacasVehiculares;
